import { defineComponent as s, inject as i, withDirectives as o } from "vue";
import { getFirstVNode as r } from "./ghl-ui.es747.js";
const g = s({
  name: "Target",
  setup() {
    const { setTargetRef: e, syncTarget: t } = i("VBinder");
    return {
      syncTarget: t,
      setTargetDirective: {
        mounted: e,
        updated: e
      }
    };
  },
  render() {
    const { syncTarget: e, setTargetDirective: t } = this;
    return e ? o(r("follower", this.$slots), [
      [t]
    ]) : r("follower", this.$slots);
  }
});
export {
  g as default
};
